import { ReduxDispatch } from '../types/redux/ReduxDispatch';

export enum NotificationActionTypes {
    ADD_NOTIFICATION = 'ADD_NOTIFICATION',
    HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'
}

export type NotificationAction =
    | ReturnType<typeof addNotification>
    | ReturnType<typeof hideNotification>;

export enum NotificationType {
    Success = "success",
    Error = "danger"
}

function addNotification(message: string, type: NotificationType) {
    return {
        type: NotificationActionTypes.ADD_NOTIFICATION,
        payload: message,
        notificationType: type
    } as const;
}

function hideNotification() {
    return {
        type: NotificationActionTypes.HIDE_NOTIFICATION
    } as const;
}

export function addNotificationToApp(message: string, type: NotificationType) {
    return (dispatch: ReduxDispatch) => {
        dispatch(addNotification(message, type));
    };
}

export function hideNotificationFromApp() {
    return (dispatch: ReduxDispatch) => {
        dispatch(hideNotification());
    };
}